<template>
		<v-row>
		<v-col>
			<v-card outlined>
				<v-card-title
					class = "justify-center secondary pa-0 body-1 white--text"
				>
					<v-icon
						small
						color = "error"
						class = "mx-2"
					>
						mdi-album
					</v-icon>
					<span>
						{{ $ml.get('recording') }}
					</span>
					
				</v-card-title>
				<v-card-text
					class = "pa-1 mt-1"
				>
					<v-row>
						<template v-for = "(item_info, idx_info) of info_fields">
							
							<v-col
								:md  = "item_info.col ? item_info.col :  6"
								:key = "idx_info"
							>
								<v-text-field
									dense
									outlined
									hide-details
									v-show 	  = "show[item_info.show_key]"
									:type 	  = "item_info.type"
									v-model   = "info[item_info.key]"
									:label 	  = "$ml.get(item_info.text)"
									:value 	  = "item_info.value ? item_info.value : ''"
									v-if 	  = "['number', 'text'].includes(item_info.type)"
								>	
									<template slot = "prepend-inner">						
										<v-icon 
											small 
											v-text = "item_info.icon" 
											class  = "pt-1"

										></v-icon>
									</template>	
									<template v-slot:append>
										<v-btn
											small
											color = "primary"
											v-show = "item_info.append"
										>
											{{ item_info.append }}
										</v-btn>
									</template>
								</v-text-field>

								<v-card outlined 
									class  	  = "pa-0 caption pb-1 pl-1" 
									height 	  = "40"
									v-else-if = "item_info.type == 'switch'"
								>
									<v-switch			
										dense						
										false-value
										hide-details
										class 			= "mt-1"			
										v-model 		= "info[item_info.key]"						
										:label 			= "$ml.get(item_info.text)"
										:prepend-icon 	= "item_info.icon"
									></v-switch>
										<!-- v-if="item_field.type == 'switch'"						 -->
										<!-- class="pt-0" -->
								</v-card>
								<searcher
									v-show 	  			= "show[item_info.show_key]"
									v-else-if 			= "item_info.type == 'select_searcher'"
									:info_to_component 	= "item_info"
									:info_to_list  	   	= "render_listed(item_info.list)"
									@receive_info	   	= "info[item_info.key] = $event"
								></searcher>

								<v-divider
									v-else-if = "item_info.type == 'line'"
								></v-divider>
							</v-col>
						</template>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>

					<v-progress-linear
				      	indeterminate
				      	v-show = "loading"
				      	color  = "primary"
				    ></v-progress-linear>
					<v-btn
						x-small
						@click = "save"
						color  = "primary"
						v-text = "$ml.get('update')"
				      	v-show = "!loading"
					></v-btn>
					<v-spacer></v-spacer>
					<v-btn-toggle
						v-show = "show.options_record"
					>
						<template
							v-for = "(opt_btn, idx_btn) of options_records"
						>
							
							<v-btn
								x-small
								:key  	= "idx_btn + 'records_btn'"
								:color 	= "opt_btn.color"
								v-text 	= "opt_btn.text"
								@click 	= "actions(opt_btn.action)"
							></v-btn>
						</template>
					</v-btn-toggle>
					<v-spacer></v-spacer>
					<v-btn
						x-small
						@click = "actions('confirm_delete')"
						color  = "error"
						v-text = "$ml.get('delete')"
				      	v-show = "!loading"
					></v-btn>

					
					
				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import searcher from "@/components/info/searcher.vue"
	export default{
		name : "recordings",
		components  : {
			searcher,	
		},
		data : () => ({
			info 			: {},
			info_fields 	: [
				{
					key 	 : 'timelapse',
					text 	 : 'timelapse',
					type 	 : 'number',
					icon   	 : 'mdi-timelapse',
					append 	 : 'seg',
					enable 	 : true,
					show_key : "timelapse",
					tip 	 : "this its for time record ",

				},
				{
					key 	 : "server_rtsp", 
					text 	 : 'server_rtsp',
					type 	 : 'text',
					icon   	 : 'mdi-router-network',					
					enable 	 : true,
					show_key : "server_rtsp",
					tip 	 : "this its set rtsp retransmission ",

				},
				{
					key 	 : 'limit_erased_recording',
					text 	 : 'limit_erased_recording',
					type 	 : 'number',
					enable 	 : true,		
					icon   	 : 'mdi-delete-clock',					
					show_key : "limit_erased_recording",					
					tip 	 : "this is for limit the erase while recording",
				},
				{
					key 	 : 'max_buffer',
					text 	 : 'max_buffer',
					type 	 : 'number',
					enable 	 : true,		
					icon   	 : 'mdi-format-line-weight',					
					show_key : "max_buffer",					
					tip 	 : "this is for size of all records capture, depent of limit",
				},
				{
					key  	 : 'amount_to_delete',
					text 	 : 'amount_to_delete',
					type  	 : 'number',
					icon   	 : 'mdi-delete-outline',
					enable 	 : true,	
					show_key : "amount_to_delete",					
					tip 	 : "Its amount of record that already not exist in folder but yes in bd",

				},
				{
					key  : 'line',
					type : 'line',
					col  : '12',
				},
				{
					key 		: 'search',
					text 		: 'search',
					placeholder : 'device',
					list 		: 'list_devices',
					key_list	: 'deviceId',
					text_list 	: 'name',
					type 		: 'select_searcher',
					key_search  : 'name',
					key_search_1 : 'deviceId',
					show_key 	: 'search',
					visible 	: true,

				},
				/*{
					key : 'enable',
					text : 'enable',
					type : 'switch',
					enable : false,				
				},
				{
					key : 'url',
					text : 'url',
					type : 'text',
					enable : false,
				},
				{
					key : 'port',
					text : 'port',
					type : 'number',
					enable : false,
				},*/
				
			],
			info_item 		: "",
			builder 		: ['timelapse','enable', 'max_buffer','amount_to_delete', 'limit_erased_recording', 'server_rtsp'],
			id_notification : 'recordings',
			bus 			: {},
			loading 		: false,
			options_records  : [
				{
					type   : 'btn',
					action : 'save_record',
					text   : 'save_record',
					color  : 'primary'
				},
				
				/*{
					type   : 'btn',
					action : 'start_record',
					text   : 'start_record',
					color  : 'success'
				},*/
				/*{
					type   : 'btn',
					action : 'confirm_del_record',
					text   : 'del_record',
					color  : 'error'
				},*/
				{
					type   : 'btn',
					action : 'confirm_del_record_non_exist',
					text   : 'del_record_non_exist',
					color  : 'error'
				},
				
			],
			permission 	  : {
				"roles": [1, 2]
			},
			show : {
				options_record   : false,
				max_buffer 		 : false,
				amount_to_delete : false,
				timelapse 		 : true,
				limit_erased_recording  : false,
				search 			: false,
				server_rtsp 	: false,
			},
			default : {
				amount_to_delete : 30,
				max_buffer 		 : 8000,
				limit_erased_recording  : 5,
				server_rtsp 			: "rtsp://cloud.alicesecurity.co:8554",
			},
			list_devices 		: [],
		}), // data

		created(){
			this.get_list();
			if (this.$Helper.current_auth_user(this.currentUser, this.permission) && this.$route.name == 'parameters'){
				this.show.options_record  	= true;
				this.show.max_buffer 	  	= true;	
				this.show.amount_to_delete  = true;
				this.show.limit_erased_recording  	= true;
				this.show.search 			= true;
			}
			if (localStorage.getItem('list_devices')) {
				this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
			}
		}, // created

		computed: {
			currentUser(){
      			return this.$store.state.auth.user;      			
      		}, // currentUser

		}, // computed

		methods :{
			
			actions(act, item, opt){
				if (act == 'confirm_delete') {
					this.$EventBus.$emit('notifications_modal',{
						type : 'confirm_delete',
						ID 	 : this.id_notification,
					});
					this.info_item = "del_parameter";
				}

				if (['save_record', 'start_record'].includes(act)) {
					this.actions_record(act);
				}

				if (act == 'confirm_del_record') {
					this.$EventBus.$emit('notifications_modal',{
						type : 'confirm_delete',
						ID 	 : this.id_notification,
					});
					this.info_item = "del_record";					
				}
				if (act == 'confirm_del_record_non_exist') {
					
					this.$EventBus.$emit('notifications_modal',{
						type : 'confirm_delete',
						ID 	 : this.id_notification,
					});
					this.info_item = "del_record_non_exist";
					
				}
			}, // actions

			get_list(){
				const api    = this.$URL + '/api/v1/parameter/' + 1;
				const api1   = this.$URL + '/api/v1/parameter';
				this.loading = true;
				this.$axios.get( api).then( res => {
					this.loading = false;
					if (res && res.data) {
						this.info = res.data;
						/*if (!this.amount_to_delete) {
							this.info.amount_to_delete 		 = this.default.amount_to_delete;
							this.info.max_buffer 			 = this.default.max_buffer; 					
							this.info.limit_erased_recording = this.default.limit_erased_recording;
						}*/
					}else{
						let info_up = {
							timeoutAlert  			: 5,
							timelapse      			: 20,
							timezone 				: this.$timezone,
							amount_to_delete 		: this.default.amount_to_delete,
							max_buffer 		 		: this.default.max_buffer,
							limit_erased_recording  : this.default.limit_erased_recording,
							server_rtsp 			: this.default.server_rtsp,
						}
						this.$axios.post(api1, info_up).then(ress =>{
							if (ress && ress.data) {
								this.info = info_up;	
								// this.info.amount_to_delete 	= this.default.amount_to_delete;
								// this.info.max_buffer 		= this.default.max_buffer; 					
							}
						}).catch(err => {
							console.log("error create recordings ", err);
							this.$EventBus.$emit('notifications_modal',{
								type 	: 'error',
								message : err 
							});			
						})
						console.log("Not found info recordings", res);
					}
				}).catch( er => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : er
					});
				});
			}, // get list

			save(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_edit", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				const api    = this.$URL + '/api/v1/parameter/' + 1;
				let info_up  = this.$Helper.format_req(this.info, this.builder);
				if (info_up &&  info_up.timelapse) {

					this.loading = true;
					this.$axios.put( api, info_up).then( res => {
						this.loading = false;
						this.$EventBus.$emit('notifications_modal',{
							type : 'updated'
						});
					}).catch( er => {
						this.loading = false;
						this.$EventBus.$emit('notifications_modal',{
							type 	: 'error',
							message : er
						});
					});
				}else{
					let msg = '';
					if (!info_up.timelapse) {
						msg += this.$ml.get('timelapse');
					}
				
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : this.$ml.get('required') + ' : ' + msg,
					})
				}
			}, // save

			del(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_delete", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				const api    = this.$URL + '/api/v1/parameter/' + 1;				
				this.loading = true;
				this.$axios.delete( api).then( res => {
					this.loading = false;

					this.$EventBus.$emit('notifications_modal',{
						type : 'deleted'
					});
					this.info = {
						name      		 		: 1,
				        enable    		 		: false,
				        amount_to_delete 		: this.default.amount_to_delete,
						max_buffer 		 		: this.default.max_buffer, 		
						limit_erased_recording 	: this.default.limit_erased_recording,		
						server_rtsp 			: this.default.server_rtsp,
				        
					};
				}).catch( er => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : er
					});
				});
			}, // del

			actions_record(act){
				const api = this.$URL + '/api/v1/parameter/action_record';
				const  { max_buffer, amount_to_delete } = this.info;
				let info_up = {
					action : act,
					 max_buffer, 
					 amount_to_delete,			
					 deviceId 	: this.info && this.info.search ? this.info.search : '',		 
				}
				this.$axios.post(api, info_up).then(res => {
					this.$EventBus.$emit('notifications_modal', {
						type  	: 'success',
						message : 'Action taking place in the background. '
					}) 
				}).catch( er => {	
					console.log("Error actions record : ", er);
					this.$EventBus.$emit('notifications_modal', {
						type  	: 'error',
						message : er
					}) 
				})
			}, // actions records
			render_listed (list){
				return this[list];
			}, // render listed

		}, // methods

		mounted(){
			let temp_bus = "notifications_modal" + this.id_notification;
			this.$EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					if (this.info_item == 'del_parameter') {
						this.del();
					}
					if (['del_record', 'del_record_non_exist'].includes(this.info_item)) {
						this.actions_record(this.info_item)
					}
				}
			});
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, 'recordings');

		}, // beforeDestroy
	};
</script>